import { createInstance } from '@optimizely/react-sdk';
import { getClientId } from './client_id';

const OptimizelyConstants = {
  EVENTS: {
    SIGNUP_CLICKED: 'Signup Clicked',
    SIGNUP_SUCCESS: 'Signup Success',
    PRO_CONVERSION: 'Pro Conversion', // Pro conversion with any subscripition plan
    PRO_CONVERSION_MONTHLY: 'Pro Conversion Monthly',
    PRO_CONVERSION_ANNUAL: 'Pro Conversion Annual',
    PRO_CONVERSION_3_YEAR: 'Pro Conversion 3 Year',
    PRO_AWARENESS_CLICK: 'Pro Awareness Click',
    PRO_AWARENESS_SEEN: 'Pro Awareness Seen'
  },
  OUTCOMES: {
    SUCCESS: 'success',
    FAILED_VALIDATION: 'failed-validation'
  }
};

// This function is used when we don't want to fetch the datafile after render
// so that there is no flashing of content. It is used when a datafile is
// passed to a react app via page props.
const initializeOptimizely = optimizelySettings => {
  // Only enable Optimizely if we can store client-side user identifier
  if (typeof window !== 'undefined' && window.localStorage && optimizelySettings) {
    const instance = createInstance({
      datafile: optimizelySettings.datafile
    });
    let userId = getClientId();
    return [instance, userId];
  }
  return [null, null];
};

// This function is used any time we just need to instantiate an optimizely
// instance without rendering any potential test content. It is helpful for
// when we want to flush out any pending optimizely events that might not have
// finished sending after an immedate redirect following trackOptimizelyEvent.
const initializeOptimizelyWithKey = sdkKey => {
  const instance = createInstance({ sdkKey });
  return instance;
};

const trackOptimizelyEvent = (instance, userId, eventType, eventOutcome = OptimizelyConstants.OUTCOMES.SUCCESS, eventAttributes = {}) => {
  eventAttributes = { ...eventAttributes, eventOutcome };
  instance.track(eventType, userId, eventAttributes);
};

export { OptimizelyConstants, initializeOptimizely, initializeOptimizelyWithKey, trackOptimizelyEvent };
